var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('Iframe',{attrs:{"link":_vm.link,"title":_vm.title}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }